import './index.scss';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.fullscreen/Control.FullScreen';
import 'leaflet.fullscreen/Control.FullScreen.css';
import 'leaflet.markercluster';
/* This code is needed to properly load the images in the Leaflet CSS */
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('./marker.svg'),
    iconUrl: require('./marker.svg'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

class MapLocation {

    constructor(liNode) {
        this.point = L.latLng(liNode.getAttribute('data-lat'), liNode.getAttribute('data-long'));
        this.tooltipHtml = liNode.innerHTML;
        this.marker = L.marker(this.point);
        this.marker.bindPopup(this.tooltipHtml, {offset: [0,-5]});
    }
}

class WidgetMap {
    constructor(root) {
        this.root = root;
        this.locations = Array.from(this.root.querySelectorAll('.locations li')).map(node => new MapLocation(node));
        this.mapContainer = this.root.querySelector('.map-container');
        this.prepareMap();
    }

    get topLeft() {
        return this.getLatLngFromString(this.root.getAttribute('data-top-left'));
    }

    get bottomRight() {
        return this.getLatLngFromString(this.root.getAttribute('data-bottom-right'));
    }

    getLatLngFromString(str) {
        const parts =str.split(',');
        return L.latLng(parts[0],parts[1]);
    }

    get boundingBox() {
        return L.latLngBounds(this.topLeft, this.bottomRight);
    }



    addMarkers() {
        this.locations.forEach(location => {
            location.marker.addTo(this.mcg);
        });
    }

    prepareMap() {

        this.map = L.map(this.mapContainer,
            {
                scrollWheelZoom:  false,
                minZoom: 5,
                maxZoom: 15,
                zoomControl: true,
                fullscreenControl: true,
                fullscreenControlOptions: {
                    forceSeparateButton: true,
                    position: 'topright',
                    title: 'Fullscreen öffnen',
                    titleCancel: 'Karte schließen'
                },
            });
        const basemap = L.tileLayer('https://osm-{s}.webpard.de/hot/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap2</a> contributors'
        });

        this.map.fitBounds(this.boundingBox);
        this.mcg = L.markerClusterGroup({
            showCoverageOnHover: true,
            zoomToBoundsOnClick: true,
            spiderfyOnMaxZoom: true,
            polygonOptions: {color: '#d80a30'},
            spiderLegPolylineOptions: {weight: 5, color: '#d80a30', opacity: 0.8}
        }).addTo(this.map);
        this.addMarkers();
        basemap.addTo(this.map);
    }

}

window.app.run(() => {
    document.querySelectorAll('.widget-map')
        .forEach((node) => {
        new WidgetMap(node);
    });
});
